import React from 'react'
import CSVReader from 'react-csv-reader'
import hooks from '../../../hooks'
import RecordsTable from './records-table'
import useBuilder from './use-builder'

const fieldsConfig = [
    { label: 'First Name', value: 'firstName', required: true },
    { label: 'Last Name', value: 'lastName' },
]

const CSVImporter = ({
    fields = fieldsConfig,
    onChange = () => {}
}) => {

    const {
        records,
        setRecords,
        columns,
        setColumn,
        toggleRow,
        selectedRecords,
        toggleAll
    } = useBuilder({ onBuilt: onChange })

    const { toastError } = hooks.useToasts()
    const onParseError = React.useCallback((err) => {
        console.error('Parsing Error:', err)
        toastError('Error parsing CSV')
    }, [toastError])

    return (
        <div style={{ paddingTop: '20px', display: 'flex', flexDirection: 'column' }}>
            <div>
                <CSVReader
                    parserOptions={{ header:false }}
                    onFileLoaded={setRecords}
                    onError={onParseError}
                />
            </div>
            <div>
                <RecordsTable
                    fieldOptions={fields}
                    columns={columns}
                    records={records}
                    onColmunChange={setColumn}
                    onToggleRecord={toggleRow}
                    selectedRecords={selectedRecords}
                    toggleAll={toggleAll}
                />
            </div>
        </div>
    )
}

export default CSVImporter
